import {CSSProperties} from "react";

export const globalColor = {
    backgroundGray: '#393838',
    primaryGreen: '#12dd36'
}

export const castShadow: CSSProperties = {
    boxShadow: '4px 4px 10px 5px rgba(0, 0 ,0 ,0.3)'
};

export const card: CSSProperties = {
    backgroundColor: 'white',
}